import { Seller, SellerUpdatePayload, SellerPagination } from 'src/types/sellers';
import { axiosInstance, endpoints } from 'src/utils/axios';
import { buildQueryParams } from 'src/hooks/use-query-params';

// ----------------------------------------------------------------------

class SellersRepository {
  static async getAll(params?: SellerPagination): Promise<{ pagination: any; items: Seller[] }> {
    try {
      const queryString = buildQueryParams(params || {});
      const response = await axiosInstance.get(`${endpoints.sellers.getAll}${queryString}`);
      return response.data;
    } catch (error) {
      throw new Error(`Failed to fetch sellers: ${error.message}`);
    }
  }


  static async getById(id: string): Promise<Seller> {
    try {
      const response = await axiosInstance.get(`${endpoints.sellers.getById}/${id}`);
      return response.data.items;
    } catch (error) {
      throw new Error(`Failed to fetch seller: ${error.message}`);
    }
  }

  static async create(seller: SellerUpdatePayload): Promise<void> {
    try {
      await axiosInstance.post(endpoints.sellers.create, seller);
    } catch (error) {
      throw new Error(`Failed to create seller: ${error.message}`);
    }
  }

  static async update(id: string, seller: SellerUpdatePayload): Promise<void> {
    try {
      await axiosInstance.put(`${endpoints.sellers.update}/${id}`, seller);
    } catch (error) {
      throw new Error(`Failed to update seller: ${error.message}`);
    }
  }

  static async delete(id: string): Promise<void> {
    try {
      // Soft delete - atualiza status para soft-deleted ao invés de deletar
      await axiosInstance.put(`${endpoints.sellers.update}/${id}`, { status: 'soft-deleted' });
    } catch (error) {
      throw new Error(`Failed to delete seller: ${error.message}`);
    }
  }
}

export const sellersRepository = SellersRepository;
